var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { getBook, initializeBooks, useBooks } from "@/05-models/book";
import { getGenreFilterSettings, updateGenreFilterSettings } from "@/05-models/user-settings";
import { RequestError } from "@/06-shared/api/request";
import { useErrorNotify } from "@/06-shared/lib/errorNotifier";
import { BooksFilter } from "@/04-features/books-filter";
import { BookPopup } from "@/04-features/book-popup";
import { CreateBook } from "@/04-features/create-book";
import { ShowBookItem } from "@/04-features/show-book-item";
import styles from "./index.module.css";
export const BooksFeed = () => {
    const books = useBooks();
    const [filters, setFilters] = useState({});
    const [selectedBook, setSelectedBook] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const genreWasChanged = useRef(false);
    const showError = useErrorNotify();
    useEffect(() => {
        initializeBooks()
            .catch(showError)
            .finally(() => setIsLoading(false));
    }, []);
    useEffect(() => {
        getGenreFilterSettings()
            .then((settings) => {
            if (!genreWasChanged.current) {
                setFilters((current) => (Object.assign(Object.assign({}, current), { genre: settings.genre || undefined })));
            }
        })
            .catch((error) => {
            if (!(error instanceof RequestError && (error.status === 401 || error.status === 403))) {
                showError(error);
            }
        });
    }, []);
    useEffect(() => {
        if (!genreWasChanged.current)
            return;
        const timeout = window.setTimeout(() => {
            var _a;
            updateGenreFilterSettings((_a = filters.genre) !== null && _a !== void 0 ? _a : "")
                .catch((error) => {
                if (!(error instanceof RequestError && (error.status === 401 || error.status === 403))) {
                    showError(error);
                }
            });
        }, 500);
        return () => window.clearTimeout(timeout);
    }, [filters.genre]);
    const changeFilters = (newFilters) => {
        if (newFilters.genre !== filters.genre) {
            genreWasChanged.current = true;
        }
        setFilters(newFilters);
    };
    const showBookDetails = (bookId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setSelectedBook(yield getBook(bookId));
        }
        catch (error) {
            showError(error);
        }
    });
    const filteredBooks = books
        .filter((book) => !filters.genre || book.genre.toLowerCase().includes(filters.genre.toLowerCase()))
        .filter((book) => filters.available === undefined || book.available === filters.available);
    return (_jsxs("section", { className: styles.feed, children: [_jsxs("div", { className: styles.header, children: [_jsx("h1", { className: styles.title, children: "\u041A\u043D\u0438\u0433\u0438" }), _jsx(CreateBook, {})] }), _jsx(BooksFilter, { filters: filters, onChange: changeFilters }), _jsxs("div", { className: styles.content, children: [isLoading && (_jsx("p", { className: styles.message, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043A\u043D\u0438\u0433..." })), (!isLoading && filteredBooks.length === 0) && (_jsx("p", { className: styles.message, children: "\u041A\u043D\u0438\u0433\u0438 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B" })), filteredBooks.map((book) => (_jsx(ShowBookItem, { book: book, onClick: () => showBookDetails(book.id) }, book.id)))] }), _jsx(BookPopup, { book: selectedBook, onClose: () => setSelectedBook(null) })] }));
};
